import { NumberField, NumberFieldProps } from './number-field';
import { FieldValues, Path } from 'react-hook-form';

export interface ManufacturerTotalFieldProps<T extends FieldValues = FieldValues>
  extends Omit<NumberFieldProps<T>, 'name'> {
  name?: Path<T>;
}

export const ManufacturerTotalField = <T extends FieldValues = FieldValues>({
  name = 'manufacturerPrice' as Path<T>,
  ...rest
}: ManufacturerTotalFieldProps<T>) => {
  return <NumberField name={name} {...rest} isSmallSize allowNegative={false} />;
};
